module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "signup-header row border-bottom-light row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', {
    staticClass: "color-6"
  }, [_vm._v("1. Your company")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.brand) + " in a nutshell.")]), _vm._v(" "), _c('h4', [_vm._v("This will help us create your company page.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.processForm.apply(null, arguments)
      }
    }
  }, [_c('avatar-uploader', {
    attrs: {
      "placeholder": "supplier"
    },
    on: {
      "uploadComplete": _vm.addUploadedAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Email (for customer contact)"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyEmail),
      expression: "form.companyEmail"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Please add your email"
    },
    domProps: {
      "value": (_vm.form.companyEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.companyEmail.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.companyEmail.required) ? _c('span', [_vm._v("Email (for customer contact) is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyEmail.email) ? _c('span', [_vm._v("Must be a valid email")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Phone (for customer contact)"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyPhone),
      expression: "form.companyPhone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "Please add your phone no."
    },
    domProps: {
      "value": (_vm.form.companyPhone)
    },
    on: {
      "blur": _vm.onPhoneBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.companyPhone.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.companyPhone.required) ? _c('span', [_vm._v("Phone (for customer contact) is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.companyPhone.numeric) ? _c('span', [_vm._v("Must be a valid phone.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Website\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.website),
      expression: "form.website"
    }],
    attrs: {
      "type": "text",
      "placeholder": "www.website.com"
    },
    domProps: {
      "value": (_vm.form.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "website", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.website.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.form.website.isWebsiteValid) ? _c('span', [_vm._v("Must be a valid website.")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5 mb-1"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.signup.supplier'
      }
    }
  }, [_c('input', {
    staticClass: "btn tertiary widest full",
    attrs: {
      "type": "button",
      "value": "Back"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn action widest full",
    attrs: {
      "type": "submit",
      "value": "Finish",
      "disabled": _vm.$v.$invalid || _vm.submittingRegistration
    }
  }, [(_vm.submittingRegistration) ? _c('loader') : _c('span', [_vm._v("Submit")])], 1)])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b67f064"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/supplier/Step2.vue
// module id = 2309
// module chunks = 0